// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_LEPRECHAUNS = [{
  id: 'leprechauns_thief',
  factionId: FACTIONS.LEPRECHAUNS,
  name: 'Ловкач',
  priceNumens: 12000,
  skinRank: 1,
}, {
  id: 'leprechauns_accountant',
  factionId: FACTIONS.LEPRECHAUNS,
  name: 'Скрижатель долгов',
  priceNumens: 41000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'leprechauns_cards',
  factionId: FACTIONS.LEPRECHAUNS,
  name: 'Карточный король',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'leprechauns_gold_legacy',
  factionId: FACTIONS.LEPRECHAUNS,
  name: 'Скряга с холмов',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'leprechauns_ruby_legacy',
  factionId: FACTIONS.LEPRECHAUNS,
  name: 'Властелин радуги',
  priceCrystals: 400,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
